import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Observable, BehaviorSubject, ReplaySubject, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

import { uniqueBy } from "app/shared/utils";

import { Patient } from "../../shared/types";
import { fuzzy } from "../../shared/utils/search";
import { FilterPageOptionEnum } from "../../shared/enums";

@Component({
	selector: "patient-overview",
	templateUrl: "patient-overview.component.html",
	styleUrls: ["patient-overview.component.scss"],
	standalone: false,
})
export class PatientOverviewComponent implements OnInit {
	pageOption = FilterPageOptionEnum.RESIDENTS;
	// @ts-expect-error TS2564
	patients$: Observable<Patient[]>;
	search$ = new BehaviorSubject<string>("");
	isSearchingSpecificPatient$: Observable<boolean> = this.search$.pipe(map((search) => search.trim().length > 0));
	private readonly patientsSource$ = new ReplaySubject<Patient[]>();

	// @ts-expect-error TS2564
	@Input() hasActiveFilters: boolean;
	// @ts-expect-error TS2564
	@Input() taskToggleValue: boolean;
	@Output() details = new EventEmitter<Patient>();
	@Output() toggleTasks = new EventEmitter<void>();

	@Input() set patients(value: Patient[]) {
		this.patientsSource$.next(value);
	}

	ngOnInit() {
		this.patients$ = combineLatest(
			this.search$.pipe(map((term) => term.trim())),
			this.patientsSource$,
			(term: string, patients: Patient[]) => ({ term, patients }),
		).pipe(
			map(({ term, patients }) => {
				if (!patients) {
					return patients;
				}

				if (/\d+/.test(term)) {
					return patients.filter((patient) => patient.room === term);
				}

				const residentByRoomAndName = fuzzy(patients, term, "fullName").concat(
					patients.filter((patient) => patient.room === term),
				);
				return uniqueBy("id", residentByRoomAndName);
			}),
		);
	}
}
